// extracted by mini-css-extract-plugin
export var compTitle = "index-module--compTitle--M55V5";
export var container = "index-module--container--JoMve";
export var description = "index-module--description--KFzBz";
export var list = "index-module--list--KAggt";
export var section = "index-module--section--9NLa0";